import HouseCardGallery from './HouseCardGallery'

export { HouseCardGallery }
